import { Component } from '@theme/component';
import { isClickedOutside, normalizeString, onAnimationEnd } from '@theme/utilities';

/**
 * A custom element that displays a localization form.
 *
 * @typedef {object} FormRefs
 * @property {HTMLDivElement} countryList - The country list element.
 * @property {HTMLInputElement} countryInput - The country input element.
 * @property {HTMLUListElement[]} countryListItems - The country list items element.
 * @property {HTMLFormElement} form - The form element.
 * @property {HTMLDivElement} liveRegion - The live region element.
 * @property {HTMLSelectElement} languageInput - The language input element.
 * @property {HTMLSpanElement} noResultsMessage - The no results message element.
 * @property {HTMLUListElement} popularCountries - The popular countries element.
 * @property {HTMLInputElement} search - The search input element.
 * @property {HTMLButtonElement} resetButton - The reset button element.
 *
 * @extends {Component<FormRefs>}
 */
class LocalizationFormComponent extends Component {
/*   connectedCallback() {
    super.connectedCallback();

    this.refs.search && this.refs.search.addEventListener('keydown', this.#onSearchKeyDown);
    this.refs.countryList && this.refs.countryList.addEventListener('keydown', this.#onContainerKeyDown);
    this.refs.countryList && this.refs.countryList.addEventListener('scroll', this.#onCountryListScroll);

    setTimeout(() => this.resizeLanguageInput(), 0);
  } */
connectedCallback() {
  super.connectedCallback();

  // PATCH: сохраняем фильтры при открытии языкового селектора
  this.refs.languageInput && this.refs.languageInput.addEventListener('focus', () => {
    if (window.location.search) {
      sessionStorage.setItem('localization_pending_filters', window.location.search);
    }
  });

  this.refs.search && this.refs.search.addEventListener('keydown', this.#onSearchKeyDown);
  this.refs.countryList && this.refs.countryList.addEventListener('keydown', this.#onContainerKeyDown);
  this.refs.countryList && this.refs.countryList.addEventListener('scroll', this.#onCountryListScroll);
  setTimeout(() => this.resizeLanguageInput(), 0);
}


  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.search && this.refs.search.removeEventListener('keydown', this.#onSearchKeyDown);
    this.refs.countryList && this.refs.countryList.removeEventListener('keydown', this.#onContainerKeyDown);
    this.refs.countryList && this.refs.countryList.removeEventListener('scroll', this.#onCountryListScroll);
  }

  // PATCH: сохраняем текущие query-параметры (фильтры, сортировка) перед сабмитом формы
/*   #appendCurrentQueryParams() {
    const { form } = this.refs;
    if (!form) return;

    const searchParams = new URLSearchParams(window.location.search);
    for (const [key, value] of searchParams.entries()) {
      if (!form.querySelector(`input[name="${CSS.escape(key)}"]`)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        form.appendChild(input);
      }
    }
  } */
/* #appendCurrentQueryParams() {
  const { form } = this.refs;
  if (!form) return;

  // Перезаписываем return_to актуальным URL включая фильтры из адресной строки
  const currentUrl = window.location.pathname + window.location.search;

  let returnToInput = form.querySelector('input[name="return_to"]');
  if (returnToInput) {
    // Перезаписываем существующий input
    returnToInput.value = currentUrl;
  } else {
    // Создаём если нет
    returnToInput = document.createElement('input');
    returnToInput.type = 'hidden';
    returnToInput.name = 'return_to';
    returnToInput.value = currentUrl;
    form.appendChild(returnToInput);
  }
} */
/* #appendCurrentQueryParams() {
  const { form } = this.refs;
  if (!form) return;

  // Определяем целевой язык из формы
  const languageInput = form.querySelector('input[name="language_code"], select[name="language_code"]');
  const countryInput = form.querySelector('input[name="country_code"]');
  
  // Берём язык из select если меняется язык, иначе текущий
  const targetLang = (languageInput instanceof HTMLSelectElement && languageInput.value)
    ? languageInput.value
    : window.__currentLocale || 'pl';

  // Переводим query string
  const searchParams = new URLSearchParams(window.location.search);
  const translations = window.__productTypeTranslations || {};
  const targetTranslations = translations[targetLang] || {};
  
  // Строим обратный маппинг: переведённое → польское (базовое)
  const plTranslations = translations['pl'] || {};
  const reverseMap = {};
  for (const [pl, translated] of Object.entries(translations[window.__currentLocale] || {})) {
    reverseMap[translated] = pl;
  }

  const newParams = new URLSearchParams();
  for (const [key, value] of searchParams.entries()) {
    if (key === 'filter.p.product_type') {
      // Сначала находим польское (базовое) значение
      const plValue = reverseMap[value] || value;
      // Затем переводим на целевой язык
      const translatedValue = targetTranslations[plValue] || plValue;
      newParams.append(key, translatedValue);
    } else {
      newParams.append(key, value);
    }
  }

  const currentPath = window.location.pathname;
  const newQuery = newParams.toString();
  const newUrl = currentPath + (newQuery ? '?' + newQuery : '');

  let returnToInput = form.querySelector('input[name="return_to"]');
  if (returnToInput) {
    returnToInput.value = newUrl;
  } else {
    returnToInput = document.createElement('input');
    returnToInput.type = 'hidden';
    returnToInput.name = 'return_to';
    returnToInput.value = newUrl;
    form.appendChild(returnToInput);
  }
} */
#appendCurrentQueryParams() {
  const { form } = this.refs;
  if (!form) return;

  // Берём фильтры из sessionStorage (сохранены при фокусе на селекторе)
  // или из текущего URL если sessionStorage пустой
  const savedSearch = sessionStorage.getItem('localization_pending_filters');
  const search = (savedSearch && savedSearch !== '') 
    ? savedSearch 
    : window.location.search;

  const languageInput = form.querySelector('select[name="language_code"]');
  const targetLang = (languageInput instanceof HTMLSelectElement && languageInput.value)
    ? languageInput.value
    : window.__currentLocale || 'pl';

  const searchParams = new URLSearchParams(search);
  const translations = window.__productTypeTranslations || {};
  const targetTranslations = translations[targetLang] || {};

  const reverseMap = {};
  for (const [pl, translated] of Object.entries(translations[window.__currentLocale] || {})) {
    reverseMap[translated] = pl;
  }

  const newParams = new URLSearchParams();
  for (const [key, value] of searchParams.entries()) {
    if (key === 'filter.p.product_type') {
      const plValue = reverseMap[value] || value;
      const translatedValue = targetTranslations[plValue] || plValue;
      newParams.append(key, translatedValue);
    } else {
      newParams.append(key, value);
    }
  }

  const currentPath = window.location.pathname;
  const newQuery = newParams.toString();
  const newUrl = currentPath + (newQuery ? '?' + newQuery : '');

  let returnToInput = form.querySelector('input[name="return_to"]');
  if (returnToInput) {
    returnToInput.value = newUrl;
  } else {
    returnToInput = document.createElement('input');
    returnToInput.type = 'hidden';
    returnToInput.name = 'return_to';
    returnToInput.value = newUrl;
    form.appendChild(returnToInput);
  }
}


  /**
   * Handles the keydown event for the container.
   *
   * @param {KeyboardEvent} event - The event object.
   */
  #onContainerKeyDown = (event) => {
    const { countryInput, countryListItems, form } = this.refs;

    switch (event.key) {
      case 'ArrowUp':
        event.preventDefault();
        event.stopPropagation();
        this.#changeCountryFocus('UP');
        break;
      case 'ArrowDown':
        event.preventDefault();
        event.stopPropagation();
        this.#changeCountryFocus('DOWN');
        break;
      case 'Enter': {
        event.preventDefault();
        event.stopPropagation();
        const focusedItem = countryListItems.find((item) => item.getAttribute('aria-selected') === 'true');

        if (focusedItem) {
          countryInput.value = focusedItem.dataset.value ?? '';
          this.#appendCurrentQueryParams(); // PATCH
          form.submit();
        }
        break;
      }
    }

    if (!this.refs.search) return;

    setTimeout(() => {
      const focusableItems = this.refs.countryListItems.filter((item) => !item.hasAttribute('hidden'));
      const focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
      const focusedItem = focusableItems[focusedItemIndex];

      if (focusedItem) {
        this.refs.search.setAttribute('aria-activedescendant', focusedItem.id);
      } else {
        this.refs.search.setAttribute('aria-activedescendant', '');
      }
    });
  };

  /**
   * Selects a country.
   *
   * @param {string} countryName - The name of the country to select.
   * @param {Event} event - The event object.
   */
  selectCountry = (countryName, event) => {
    event.preventDefault();
    const { countryInput, form } = this.refs;

    countryInput.value = countryName;
    this.#appendCurrentQueryParams(); // PATCH
    form?.submit();
  };

  /**
   * Changes the language of the localization form.
   *
   * @param {Event} event - The event object.
   */
  changeLanguage(event) {
    const { form, languageInput } = this.refs;
    const value = event.target instanceof HTMLSelectElement ? event.target.value : null;

    if (value) {
      languageInput.value = value;
      this.resizeLanguageInput();
      this.#appendCurrentQueryParams(); // PATCH
      form.submit();
    }
  }

  resizeLanguageInput() {
    const { languageInput } = this.refs;

    if (!languageInput || CSS.supports('field-sizing', 'content')) return;

    for (const option of languageInput.options) {
      if (!option.selected) {
        option.dataset.optionLabel = option.textContent || '';
        option.innerText = '';
      }
    }

    languageInput.style.width = 'fit-content';
    const originalElementWidth = `${Math.ceil(languageInput.offsetWidth) + 1}px`;

    if (languageInput.offsetWidth > 0) {
      languageInput.style.width = originalElementWidth;
    }

    for (const option of languageInput.options) {
      if (option.dataset.optionLabel) {
        option.textContent = option.dataset.optionLabel;
        delete option.dataset.optionLabel;
      }
    }
  }

  #findMatches(
    searchValue,
    countryEl,
    options = {
      matchLabel: true,
      matchAlias: true,
      matchIso: true,
      matchCurrency: true,
      labelMatchStart: false,
      aliasExactMatch: false,
    }
  ) {
    let matchTypes = {};
    const { aliases, value: iso } = countryEl.dataset;

    if (options.matchLabel) {
      const countryName = normalizeString(countryEl.querySelector('.country')?.textContent ?? '');

      if (!countryName) return matchTypes;

      matchTypes.label = options.labelMatchStart
        ? countryName.startsWith(searchValue)
        : countryName.includes(searchValue);
    }

    if (options.matchCurrency) {
      const currency = normalizeString(countryEl.querySelector('.localization-form__currency')?.textContent ?? '');
      matchTypes.currency = currency.includes(searchValue);
    }

    if (options.matchIso) {
      matchTypes.iso = normalizeString(iso ?? '') == searchValue;
    }

    if (options.matchAlias) {
      const countryAliases = aliases?.split(',').map((alias) => normalizeString(alias));

      if (!countryAliases) return matchTypes;

      matchTypes.alias =
        countryAliases.length > 0 &&
        countryAliases.find((alias) =>
          options.aliasExactMatch ? alias === searchValue : alias.startsWith(searchValue)
        ) !== undefined;
    }

    return matchTypes;
  }

  #highlightMatches(text, searchValue) {
    if (!text || !searchValue) return text ?? '';

    const normalizedText = normalizeString(text);
    const normalizedSearch = normalizeString(searchValue);
    const startIndex = normalizedText.indexOf(normalizedSearch);

    if (startIndex === -1) return text;

    const endIndex = startIndex + normalizedSearch.length;
    const before = text.slice(0, startIndex);
    const match = text.slice(startIndex, endIndex);
    const after = text.slice(endIndex);

    let result = '';
    if (before) {
      result += `<mark>${before}</mark>`;
    }
    result += match;
    if (after) {
      result += `<mark>${after}</mark>`;
    }
    return result;
  }

  filterCountries() {
    const { countryList, countryListItems, liveRegion, noResultsMessage, popularCountries, resetButton, search } =
      this.refs;
    const { labelResultsCount } = this.dataset;
    const searchValue = normalizeString(search.value);
    let countVisibleCountries = 0;

    resetButton.toggleAttribute('hidden', !searchValue);

    if (popularCountries) {
      popularCountries.toggleAttribute('hidden', Boolean(searchValue));
    }

    const wrapper = this.querySelector('.country-selector-form__wrapper');
    if (wrapper) {
      wrapper.classList.toggle('is-searching', !!searchValue);
    }

    for (const countryEl of countryListItems) {
      if (searchValue === '') {
        countryEl.removeAttribute('hidden');
        const countrySpan = countryEl.querySelector('.country');
        if (countrySpan) {
          // eslint-disable-next-line no-self-assign
          countrySpan.textContent = countrySpan.textContent;
        }
        countVisibleCountries++;
      } else {
        const matches = this.#findMatches(searchValue, countryEl);

        if (matches.label || matches.alias || matches.iso || matches.currency) {
          countryEl.removeAttribute('hidden');
          const countrySpan = countryEl.querySelector('.country');
          if (countrySpan) {
            countrySpan.innerHTML = this.#highlightMatches(countrySpan.textContent, searchValue);
          }
          countVisibleCountries++;
        } else {
          countryEl.setAttribute('hidden', '');
        }
      }
    }

    if (liveRegion && labelResultsCount) {
      liveRegion.innerText = labelResultsCount.replace('[count]', `${countVisibleCountries}`);
    }

    noResultsMessage.hidden = countVisibleCountries > 0;
    countryList.scrollTop = 0;
  }

  #changeCountryFocus(direction) {
    const { countryListItems } = this.refs;
    const focusableItems = countryListItems.filter((item) => !item.hasAttribute('hidden'));
    const focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
    const focusedItem = focusableItems[focusedItemIndex];
    let itemToFocus;

    if (direction === 'UP') {
      itemToFocus =
        focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
    } else {
      itemToFocus =
        focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
    }

    if (focusedItem) {
      focusedItem.setAttribute('aria-selected', 'false');
    }
    itemToFocus?.setAttribute('aria-selected', 'true');
    itemToFocus?.focus();
  }

  resetCountriesFilter(event) {
    const { search } = this.refs;

    event.stopPropagation();
    search.value = '';
    this.filterCountries();
    search.setAttribute('aria-activedescendant', '');
    search.focus();
  }

  #onSearchKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    this.#onContainerKeyDown(event);
  };

  resetForm() {
    const { search } = this.refs;

    if (!search) return;

    if (search.value != '') {
      search.value = '';
      this.filterCountries();
      search.setAttribute('aria-activedescendant', '');
    }
  }

  focusSearchInput = () => {
    const { search } = this.refs;

    search?.focus();
  };

  #onCountryListScroll = (event) => {
    const countryFilter = this.querySelector('.country-filter');
    const countryList = event.target instanceof HTMLElement ? event.target : null;

    if (countryFilter && countryList) {
      const shouldShowBorder = countryList.scrollTop > 0;
      countryFilter.classList.toggle('is-scrolled', shouldShowBorder);
    }
  };
}

/**
 * A custom element that displays a dropdown localization form.
 *
 * @typedef {object} DropdownRefs
 * @property {HTMLButtonElement} button - The button element.
 * @property {HTMLDivElement} panel - The panel element.
 * @property {LocalizationFormComponent} localizationForm - The localization form component.
 *
 * @extends {Component<DropdownRefs>}
 */
class DropdownLocalizationComponent extends Component {
  get isHidden() {
    return this.refs.panel.hasAttribute('hidden');
  }

  toggleSelector() {
    return this.isHidden ? this.showPanel() : this.hidePanel();
  }

  showPanel() {
    if (!this.isHidden) return;

    this.addEventListener('keyup', this.#handleKeyUp);
    document.addEventListener('click', this.#handleClickOutside);

    this.refs.panel.removeAttribute('hidden');
    this.refs.button.setAttribute('aria-expanded', 'true');

    onAnimationEnd(this.refs.panel, () => {
      this.#updateWidth();
      this.refs.localizationForm?.focusSearchInput();
    });
  }

  hidePanel = () => {
    if (this.isHidden) return;

    this.removeEventListener('keyup', this.#handleKeyUp);
    document.removeEventListener('click', this.#handleClickOutside);

    this.refs.button?.setAttribute('aria-expanded', 'false');
    this.refs.panel.setAttribute('hidden', '');
    this.refs.localizationForm?.resetForm();
  };

  #handleClickOutside = (event) => {
    if (isClickedOutside(event, this)) {
      this.hidePanel();
    }
  };

  #updateWidth() {
    this.style.setProperty('--width', `${this.refs.localizationForm.offsetWidth}px`);
  }

  #handleKeyUp = (event) => {
    switch (event.key) {
      case 'Escape':
        this.hidePanel();
        event.stopPropagation();
        this.refs.button?.focus();
        break;
    }
  };
}

/**
 * A custom element that displays a drawer localization form.
 *
 * @typedef {object} DrawerRefs
 * @property {HTMLDialogElement} dialog - The dialog element.
 * @property {LocalizationFormComponent} localizationForm - The localization form component.
 *
 * @extends {Component<DrawerRefs>}
 */
class DrawerLocalizationComponent extends Component {
  toggle(event) {
    const { target } = event;
    const { localizationForm } = this.refs;

    if (!localizationForm || !(target instanceof HTMLDetailsElement)) return;

    const countryList = localizationForm.querySelector('.country-selector-form__wrapper');

    if (target.open) {
      if (countryList) countryList.addEventListener('scroll', this.#onCountryListScroll);
      onAnimationEnd(target, localizationForm.focusSearchInput);
    } else {
      countryList?.removeEventListener('scroll', this.#onCountryListScroll);
      localizationForm.resetForm();
    }
  }

  #onCountryListScroll = (event) => {
    const countryFilter = this.querySelector('.country-filter');
    const countryList = event.target instanceof HTMLElement ? event.target : null;

    if (countryFilter && countryList) {
      const shouldShowBorder = countryList.scrollTop > 0;
      countryFilter.classList.toggle('is-scrolled', shouldShowBorder);
    }
  };
}

if (!customElements.get('localization-form-component')) {
  customElements.define('localization-form-component', LocalizationFormComponent);
}

if (!customElements.get('dropdown-localization-component')) {
  customElements.define('dropdown-localization-component', DropdownLocalizationComponent);
}

if (!customElements.get('drawer-localization-component')) {
  customElements.define('drawer-localization-component', DrawerLocalizationComponent);
}
